import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ smooth = false }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    // scroll instantly (or smoothly if you pass smooth={true})
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: smooth ? "smooth" : "instant"
    });
  }, [pathname, smooth]);

  return null; // this component renders nothing
};

export default ScrollToTop;
